import { render, staticRenderFns } from "./ProcedureEvidenceForm.vue?vue&type=template&id=681be1e6&scoped=true"
import script from "./ProcedureEvidenceForm.vue?vue&type=script&lang=js"
export * from "./ProcedureEvidenceForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=681be1e6&prod&scoped=true&lang=css&external"
import style1 from "./ProcedureEvidenceForm.vue?vue&type=style&index=1&id=681be1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681be1e6",
  null
  
)

export default component.exports